import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { LegacyAppRedirect } from '@/components/auth/LegacyAppRedirect';
import { useAuthStore } from '@/stores/authStore';
import { isMigratedLegacyAccount } from '@/utils/legacyAccess';

export const ProtectedRoute = () => {
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isMigratedLegacyAccount(user)) {
    return <LegacyAppRedirect />;
  }

  return <Outlet />;
};
